// angular
//     .module("Dropzone", [])
//     .factory("DropzoneFactory", DropzoneFactory);

/* @ngInject */
export default function DropzoneFactory($window) {
    return $window.Dropzone;
}



// WEBPACK FOOTER //
// ./src/app/common/angular/globalFactories/dropzoneFactory.js